import './bootstrap'
import './modules/theme-mode'

$(function() {
	const windowReady = () => {
		const blockBody = new KTBlockUI(document.querySelector("#kt_body"))
		blockBody.block()

		if (blockBody.isBlocked()) {
			blockBody.release()
		}
	}
	
	if (document.readyState === "complete")
		windowReady()
	else
		window.addEventListener('load', windowReady());

	const blockUI = new KTBlockUI(document.querySelector("#kt_content"))
	if (blockUI.isBlocked()) {
		blockUI.release()
	} 

	$('form').submit(function() {
		if (!$(this).valid()) {
			return false
		} 

		blockUI.block()

		return true
	});
	
	$('.form-select:not(.datatable-input)').on('change', function () {
		$(this).valid()
	})
	
	setTimeout(function() {
		if($('.alert-notice').hasClass("show")) {
			$(".alert-notice").fadeOut("slow", function() {
				$(this).remove()
			})
		}
	}, 3000)
})